import { userConstants } from '../constants'

const initialState = {
  currentUser: null,
  validSession: false,
  authLoading: true,
  registerLoading: false,
  loginLoading: false,
  token: '',
  securityBlockedError: false,
  securityBlockedMessage: '',
  recapsula: '',
}

export const currentUser = state => state.userReducers.currentUser

const userReducer = (state = initialState, action) => {
  switch (action.type) {
    // Incapsula
    case userConstants.INCAPSULA_CAPTCHA:
      return { ...state, recapsula: action.response.source }

    // Register
    case userConstants.REGISTER_REQUEST:
      return { ...state, registerLoading: true }
    case userConstants.REGISTER_SUCCESS:
      return { ...state, registerLoading: true, token: action.response.token }
    case userConstants.REGISTER_FAILURE:
      return { ...state, registerLoading: false }

    // Login
    case userConstants.LOGIN_REQUEST:
      return { ...state, loginLoading: true }
    case userConstants.LOGIN_FAILURE:
      return { ...state, loginLoading: false }

    case userConstants.UPDATE_USER_SUCCESS: {
      if (!action.response || !action.response.user) return state
      const u = action.response.user
      const detail = u.user_detail || u
      const prev = state.currentUser
      const nextUser = {
        ...prev,
        firstname: detail.firstname ?? prev?.firstname,
        lastname: detail.lastname ?? prev?.lastname,
        language: detail.language ?? prev?.language,
        dob: detail.dob ?? prev?.dob,
        country: detail.country ?? prev?.country,
      }
      if (prev?.user_detail) {
        nextUser.user_detail = {
          ...prev.user_detail,
          firstname: detail.firstname ?? prev.user_detail.firstname,
          lastname: detail.lastname ?? prev.user_detail.lastname,
          language: detail.language ?? prev.user_detail.language,
        }
      }
      return { ...state, currentUser: nextUser }
    }

    // Session
    case userConstants.SESSION_USER_SUCCESS:
      return {
        ...state,
        loginLoading: false,
        registerLoading: false,
        currentUser: {
          ...action.response.user,
          firstname: action.response.user.user_detail.firstname,
          lastname: action.response.user.user_detail.lastname,
          language: action.response.user.user_detail.language,
          dob: action.response.user.user_detail.dob,
          country: action.response.user.user_detail.country,
        },
        validSession: true,
        authLoading: false,
      }
    case userConstants.SESSION_USER_FAILURE:
      return {
        ...state,
        loginLoading: false,
        registerLoading: false,
        currentUser: {},
        validSession: false,
        authLoading: false,
      }

    case userConstants.SECURITY_BLOCKED:
      return {
        ...state,
        securityBlockedError: true,
        securityBlockedMessage: action.error.errors.message,
      }

    case userConstants.CLEAR_STATE:
      return {
        ...state,
        securityBlockedError: false,
        securityBlockedMessage: '',
      }

    // Logout
    case userConstants.LOGOUT:
      return { ...state, currentUser: initialState.currentUser, validSession: false }
    default:
      return state
  }
}

export default userReducer
